<!-- 譲渡前のダイアログ -->
<template>
  <div>
    <ItemDialog ref="validFramesConfirmation" image-type="alert">
      <template #content-area>
        <p style="text-align: center">
          <strong>{{ count }}枚</strong><br />
          使用します。<br />
          よろしいですか？
        </p>
      </template>
      <template #button-area>
        <ItemButton label="OK" action-type="btn-primary" @clicked="okClick" />

        <ItemButton
          label="キャンセル"
          action-type="btn-cancel"
          @clicked="cancelClick"
        />
      </template>
    </ItemDialog>
    <!-- 譲渡前のダイアログ -->
  </div>
</template>

<script>
export default {
  name: "DialogValidFramesConfirmation",
  props: {
    count: {
      type: Number,
      required: false,
      default: null,
    },
  },
  methods: {
    openDialog() {
      this.$refs.validFramesConfirmation.open();
    },
    closeDialog() {
      this.$refs.validFramesConfirmation.close();
    },
    okClick() {
      this.closeDialog();
      this.$emit("okClicked");
    },
    cancelClick() {
      this.$emit("cancelClicked");
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  text-align: center;
  line-height: 30px;
  margin-top: 15px;
}
strong {
  font-size: 50px;
  color: #000000;
}
</style>
